import { useDelay } from '@quickmd-llc/frontend-utils';
import {
  COMPLETE_BOOKING_ROUTE_ID,
  COMPLETE_PROFILE_ROUTE_ID,
  CONFIRM_YOUR_NUMBER_ROUTE_ID,
  CREATE_PASSWORD_ROUTE_ID,
  EMAIL_ROUTE_ID,
  ID_VERIFICATION_ROUTE_ID,
  PHONE_ROUTE_ID,
  RESCHEDULE_ROUTE_ID,
  SCHEDULE_ROUTE_ID,
  SERVICES_ROUTE_ID,
} from 'constants/routeIds';
import * as React from 'react';
import { useMatches } from 'react-router-dom';

const LazyChatWidgetComponent = React.lazy(() =>
  import('./EagerChatWidget').then((module) => ({
    default: module.EagerChatWidget,
  })),
);

const CHAT_WIDGET_LOADING_DELAY = 3000;

const rebookingIds = new Set([
  SERVICES_ROUTE_ID,
  SCHEDULE_ROUTE_ID,
  RESCHEDULE_ROUTE_ID,
  COMPLETE_BOOKING_ROUTE_ID,
  EMAIL_ROUTE_ID,
  PHONE_ROUTE_ID,
  CONFIRM_YOUR_NUMBER_ROUTE_ID,
  COMPLETE_PROFILE_ROUTE_ID,
  CREATE_PASSWORD_ROUTE_ID,
  ID_VERIFICATION_ROUTE_ID,
]);

export function LazyChatWidget() {
  // wait a few seconds before loading so as to not impact page speed
  const loadChat = useDelay(CHAT_WIDGET_LOADING_DELAY);
  const isInChatRelevantArea = useMatches().some((x) => rebookingIds.has(x.id));

  return loadChat && isInChatRelevantArea && !window.ReactNativeWebView ? (
    <LazyChatWidgetComponent />
  ) : null;
}
